// extracted by mini-css-extract-plugin
export default {"LoadingPage":"LoadingPage_LoadingPage__8+hZM","Text":"LoadingPage_Text__TpmNU"};